export const normalizeSymbols = (text: string): string =>
  text
    .replace(/\(TM\)/gi, '™')
    .replace(/\(R\)/gi, '®')
    .replace(/\(C\)/gi, '©');
